import {
  useCheckbox,
  Text,
  CheckboxProps,
  chakra,
  Box,
} from '@chakra-ui/react';

export interface CustomBadgeCheckboxProps extends CheckboxProps {
  label: string;
}

export const CustomBadgeCheckbox = ({
  label,
  ...props
}: CustomBadgeCheckboxProps) => {
  const { state, getInputProps, getLabelProps, htmlProps, getCheckboxProps } =
    useCheckbox(props);

  return (
    <Box {...getCheckboxProps}>
      <chakra.label
        display='flex'
        flexDirection='row'
        alignItems='center'
        gridColumnGap={2}
        w='fit-content'
        bgColor={state.isChecked ? 'purple.200' : 'white.100'}
        borderColor={state.isChecked ? 'primary.500' : 'grey.200'}
        borderRadius={18}
        borderWidth={1}
        color={state.isChecked ? 'primary.500' : 'grey.200'}
        fontSize={14}
        cursor='pointer'
        px={4}
        py={1.5}
        {...htmlProps}
      >
        <input {...getInputProps()} hidden />
        <Text {...getLabelProps()}>{label}</Text>
      </chakra.label>
    </Box>
  );
};
